import { Menu } from "antd";
import React from "react";
import { createPortal } from "react-dom";
import { EBButtonV2Props } from "../EBButtonV2";
import { EBModalV2 } from "../EBModalV2";

export interface ModalLinkedMenuItemProps {
  uniqueKey: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  modalBody: React.ReactNode;
  modalHeader?: React.ReactNode;
  formModalSize?: "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
  primaryButtonProps?: EBButtonV2Props;
  onOpen?: () => void;
}

export function ModalLinkedMenuItem(props: ModalLinkedMenuItemProps) {
  let modalId = props.uniqueKey + "-modal";
  let modalCloseBtnId = props.uniqueKey + "-modal-close-button";

  return [
    <span
      key={props.uniqueKey}
      style={{
           display: "inline-block", 
           width: "100%", 
           cursor: props.disabled ? "not-allowed" : "pointer",
           opacity: props.disabled ? 0.6 : 1
      }}
      onClick={(e) => {
        if (props.disabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        if (props.onOpen) props.onOpen();
      }}
      data-bs-toggle={props.disabled ? undefined : "modal"}
      data-bs-target={props.disabled ? undefined : "#" + modalId}
    >
      {props.icon && <span style={{marginRight: '8px'}}>{props.icon}</span>}
      {props.label}
    </span>,

    createPortal(
      <EBModalV2
        key={`${props.uniqueKey}-portal`}
        body={props.modalBody}
        header={props.modalHeader}
        id={modalId}
        modalSize={props.formModalSize}
        primaryButtonProps={props.primaryButtonProps}
        closeButtonId={modalCloseBtnId}
      />,
      document.body
    ) as any
  ] as any;
}
